import UserProfileServices from '../services/userProfileServices';

import UserProfileBody from '../types/UserProfileBody';
import UserActivityLog from '../types/UserActivityLog';
import { UserProfileActions } from '../types/UserProfileAction';

const userProfile = (id: string) => (dispatch: any) => {
  const success = (data: UserProfileBody): UserProfileActions => ({
    type: 'USER_PROFILE_SUCCESS', data
  });

  UserProfileServices.byId(id)
    .then((res: any) => dispatch(success(res)))
}

const activityLog = (limit: number, skip?: number) => (dispatch: any) => {
  const success = (data: UserActivityLog[]): UserProfileActions => ({
    type: 'USER_ACTIVITY_LIST_SUCCES', data
  })

  UserProfileServices.activityLog(limit,skip)
    .then((res: any) => dispatch(success(res)));
}

export default {
  userProfile,
  activityLog,
};